import React from 'react';
import './styles.css';
var DefaultValueBox = function (_a) {
    var x = _a.x, y = _a.y;
    return (React.createElement("div", { className: 'valueBox', "data-testid": 'value-box' },
        "x: ",
        x,
        React.createElement("br", null),
        "y: ",
        y));
};
export default DefaultValueBox;
